import { Button } from "../button/button";
import { IconButton } from "../button/icon-button";
import { Icon } from "../icon/icon";
import "./header.scss";

interface HeaderProps {
  title?: string;
  // Alterado de string para React.ReactNode para suportar links e tags HTML
  description?: React.ReactNode;
  backgroundImage?: string;
  showBackButton?: boolean;
  breadcrumbs?: Array<{ label: string; href: string }>;
}

export function Header({
  title,
  description,
  backgroundImage,
  showBackButton = false,
  breadcrumbs = [],
}: HeaderProps) {
  return (
    <header
      className="header"
      style={{
        backgroundImage: backgroundImage
          ? `url(${backgroundImage})`
          : undefined,
      }}
    >
      <div className="header__container">
        <div className="header__top">
          <h1 className="header__logo">{title || "Logo"}</h1>
          {showBackButton && (
            <IconButton
              onClick={() => window.history.back()}
              ariaLabel="Go back"
              icon={<Icon name="arrow-left" title="Go back" />}
              size="lg"
              className="header__back"
            />
          )}

          {breadcrumbs.length > 0 && (
            <nav className="header__breadcrumbs" aria-label="Breadcrumb">
              <ul>
                {breadcrumbs.map((crumb, index) => (
                  <li key={index}>
                    <Button
                      variant="ghost"
                      size="md"
                      to={crumb.href}
                      className="header__breadcrumb-link"
                    >
                      {crumb.label}
                    </Button>
                    {index < breadcrumbs.length - 1 && (
                      <span className="header__breadcrumb-separator">/</span>
                    )}
                  </li>
                ))}
              </ul>
            </nav>
          )}
        </div>

        {/* Mudamos a tag de <p> para <div> para evitar problemas de semântica HTML,
            já que tags <p> não podem conter blocos ou certos elementos inline complexos */}
        {/* Dentro do componente Header.tsx */}
        {description && (
          <div
            className="header__description"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
      </div>
    </header>
  );
}
